import React from 'react';
import { toast } from 'react-toastify';
import styles from '../../src/app.scss';
import 'react-toastify/dist/ReactToastify.css';

// Toast UI component
const ToastContent = ({ title, message, className }) => {
  return (
        <div className={`${styles.toast} ${className}`}>
            {
                className === 'error' && (
                    <img src="\assets\errorpic.png" alt="img" className='img-fluid' />
                )
            }
            {
                className === 'success' && (
                    <img src="\assets\successpic.png" alt="img" className='img-fluid' />
                )
            }
            {
                className === 'warning' && (
                    <img src="\assets\warningpic.png" alt="img" className='img-fluid' />
                )
            }

            <div>
                <h6 className={styles.title}>{title}</h6>
                <p className={styles.message}>{message}</p>
            </div>
        </div>
  );
};

// Static method to show toast
const show = (type = 'success', title = '', message = '') => {
  toast(<ToastContent title={title} message={message} className={type} />, {
    autoClose: 4000,
    position: 'top-right',
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: 'light',
    closeButton: false,
  });
};

// Export an object that includes show
const CustomToast = {
  show,
};

export default CustomToast;